import React, {Fragment, useState, useEffect, useContext} from 'react';
import axios from 'axios';

import errorHandler from '../../../../../hoc/ErrorHandler';
import context from '../../../../../context/auth-context';
import {FORM_CONTROL_PROPS_GENERATOR as controlProps} from '../../../../../constants';
import Input from '../../../../UI/Input/Input';
import PageTitle from '../../../../UI/PageTitle/PageTitle';

const General = props => {

    const [currentState, modifyState] = useState({
        generalSettingsForm: {
            sessionTimeout: controlProps('input', {
                type: 'number',
                id: 'Session timeout in minutes'
            }, ''),
            timeZone: controlProps('select', {
                options: [],
                id: 'Time zone'
            }, ''),
            documentEncryption: controlProps('checkbox', {
                type: 'checkbox',
                id: 'Document encryption',
                checked: false
            }, false)
        },
        error: false
    });

    const authContext = useContext(context);
    const generalSettingsFormElementsArray = [];
    const baseColorsFormElementsArray = [];
    const formData = {};
    

    let clonedGeneralSettingsForm = {
        ...currentState.generalSettingsForm
    }

    const clonedTimezoneFormControlConfig = {
        ...clonedGeneralSettingsForm.timeZone.formControlConfig
    }

    let clonedTimezoneFormControlConfigOptions = clonedTimezoneFormControlConfig.options;

    useEffect(() => {
        axios.get(`/timezones/${authContext.companyCode}`)
        .then(response => {
            response.data.map(timeZone => {
                clonedTimezoneFormControlConfigOptions.push({value: timeZone.id, id: timeZone.name});
                clonedTimezoneFormControlConfig.options = clonedTimezoneFormControlConfigOptions;
                return clonedGeneralSettingsForm.timeZone.formControlConfig = clonedTimezoneFormControlConfig
            });
            modifyState({
                ...currentState,
                generalSettingsForm: clonedGeneralSettingsForm
            });
        })
        .catch(error => {
            modifyState({
                ...currentState,
                error: error.message
            });
        });

        return () => {
            modifyState({
                ...currentState,
                error: false
            })
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authContext.companyId]);

    const inputChangedHandler = (event, inputIdentifier) => {
        const updatedGeneralSettingsForm = {
            ...currentState.generalSettingsForm
        };

        const updatedGeneralSettingsFormElement = {
            ...updatedGeneralSettingsForm[inputIdentifier]
        };

        if (updatedGeneralSettingsFormElement.formControl === 'checkbox') {
            updatedGeneralSettingsFormElement.formControlConfig.checked = updatedGeneralSettingsFormElement.value = updatedGeneralSettingsFormElement.formControlConfig.checked ? false : true;
        }else {
            updatedGeneralSettingsFormElement.value = event.target.value;
        }
        
        updatedGeneralSettingsForm[inputIdentifier] = updatedGeneralSettingsFormElement;

        return modifyState({
            ...currentState,
            generalSettingsForm: updatedGeneralSettingsForm
        });
    }

    for(let key in currentState.generalSettingsForm) {
        generalSettingsFormElementsArray.push({
            id: key,
            config: currentState.generalSettingsForm[key]
        });
    }

    for(let key in currentState.baseColors) {
        baseColorsFormElementsArray.push({
            id: key,
            config: currentState.baseColors[key]
        });
    }

    const submitHandler = event => {
        event.preventDefault();
        for(let formElementIdentifier in currentState.generalSettingsForm) {
            formData[formElementIdentifier] = currentState.generalSettingsForm[formElementIdentifier].value
        }
    }

    return(
        <Fragment>
            <PageTitle title='General settings' search={false} />

            <div className="page-content">
                <form autoComplete='off' onSubmit={submitHandler}>
                    <p style={{margin: '10px 0', fontSize: '15px', fontWeight: '700'}}>Time out, Time zone and Document encryption</p>
                    <div className="row">
                        {generalSettingsFormElementsArray.map(formElement => {
                            return (
                                <div key={formElement.id} className="col-md-4">
                                    <Input formcontrol={formElement.config.formControl} formControlConfig={formElement.config.formControlConfig} value={formElement.config.value} changed={(event) => inputChangedHandler(event, formElement.id)} />
                                </div>
                            );
                        })}
                    </div>

                    <p style={{margin: '10px 0', fontSize: '15px', fontWeight: '700'}}>Company languages:</p>

                    <p style={{margin: '10px 0', fontSize: '15px', fontWeight: '700'}}>Default company language:</p>
                    <button type="submit" className="btn btn-raised btn-primary">Submit</button>
                </form>
            </div>
        </Fragment>
    );
}

export default errorHandler(General, axios);